App.factory('statesService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function StatesService() {
        // TODO remove me
        this.dataCityLists = function(data) {
            return baseService.confirm(Config.API_URL + '/city', data).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };

        this.dataCitybyZipCodeLists = function(data) {
            return baseService.confirm(Config.API_URL + '/city/byZipCode', data).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };
        
    }
    return new StatesService();
}]);